// ==========================================================================
// KV Crossfade Slider
// ==========================================================================

export default class KVSlider {
	constructor() {
		this.slider = document.querySelector('.kv_slider');
		this.slides = document.querySelectorAll('.kv_slide');
		this.currentIndex = 0;
		this.interval = 4000; // 4秒ごとに切り替え
		this.timer = null;

		if (!this.slider || this.slides.length === 0) return;

		this.init();
	}

	init() {
		// 最初のスライドをアクティブに
		this.slides[0].classList.add('is-active');

		// 自動再生開始
		if (this.slides.length > 1) {
			this.start();
		}
	}

	start() {
		this.timer = setInterval(() => {
			this.next();
		}, this.interval);
	}

	stop() {
		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
		}
	}

	next() {
		// 現在のスライドから is-active を削除
		this.slides[this.currentIndex].classList.remove('is-active');

		// 次のインデックスを計算
		this.currentIndex = (this.currentIndex + 1) % this.slides.length;

		// 次のスライドに is-active を追加
		this.slides[this.currentIndex].classList.add('is-active');
	}

	goTo(index) {
		if (index < 0 || index >= this.slides.length || index === this.currentIndex) {
			return;
		}

		this.slides[this.currentIndex].classList.remove('is-active');
		this.currentIndex = index;
		this.slides[this.currentIndex].classList.add('is-active');
	}
}

// Initialize KV slider
document.addEventListener('DOMContentLoaded', () => {
	new KVSlider();
});
